<template>
  <div>
    <el-form :model="query" ref="queryForm" :inline="true">
      <el-form-item label="客户类型：" >
        <el-select v-model="query.customerRelationType" placeholder="请选择" clearable size="small">
          <el-option :label="-1" value="全部"></el-option>
          <el-option :label="1" value="直属客户"></el-option>
          <el-option :label="0" value="团队客户"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="客户状态：" >
        <el-select v-model="query.customerRelationType" placeholder="请选择" clearable size="small">
          <el-option :label="-1" value="全部"></el-option>
          <el-option :label="1" value="开发客户"></el-option>
          <el-option :label="0" value="继承客户"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="客户转入时间：">
        <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleDownload" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import courseOrderApi from '@/api/course/courseOrder'
import { filterEmpty } from '@/utils'
export default {
  props: ['isIntegral'],
  data() {
    return {
      dateTime: [],
      list: [],
      total: 0,
      listLoading: true,
      query: {

      },
      topicClassOptions: [],
    }
  },
  created() {
  },
  methods: {
    handleDownload() {
      this.query.startTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[0] : undefined
      this.query.endTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[1] : undefined

      return this.$common.confirm('是否确认导出')
        .then(() => courseOrderApi.exportCourseOrderReconciliation(filterEmpty(this.query))).then((res) => {
          if (res.code === '0') {
            setTimeout(() => {
              this.$emit('created')
            }, 500)

          }
        })
    },

  }

}
</script>

<style>
</style>